import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useQueryClient,
} from "react-query";
import {
  addNewBlog,
  addSlider,
  getSliderList,
  ChangeSliderStatus,
  updateSlider,
  addCategoryQuestion,
  getCategoryList,
  deleteCategory,
  updateCategory,
  addNewASkQuestion,
  deleteAskQuestion,
  updateAskQuestion,
  getAskQuestionList,
  fetchAllCatergory,
  addNewPeroperty,
  getPropertyList,
  getALLPropertyList,
  addNewNotification,
  deletePropertyLevelOne,
  updatePropertyLevelOne,
  addNewPropertyLevelTow,
  getPropertyListLevelTow,
  deletePropertyLevel2,
  updatePropertyLevel2,
  addNewCountry,
  deleteCountry,
  updateCountry,
  getCountryList,
  addNewProvince,
  deleteProvince,
  updateProvince,
  getProvinceList,
  deleteCity,
  updateCity,
  getCityList,
  addNewCity,
  addNewArea,
  updateArea,
  getAreaList,
  deleteArea,
  getCountryOption,
  getProvinceOption,
  addProductLevel,
  updateProductLevel,
  deleteProductLevel,
  getLevel1List,
  getLevve2List,
  addNewBrand,
  updateBrand,
  deleteBrand,
  getBrandList,
  addNewGender,
  updateGender,
  deleteGender,
  getGenderList,
  addNewOccation,
  updateOccation,
  deleteOccation,
  getOccationList,
  changeStatusOccation,
  ChangeRockedProductStatus,
  DeleteRockedProduct,
  getRockedProductList,
  deleteFinishedProduct,
  applyExitProduct,
  getFinishedProduct,
  getLevel3List,
  getInformationDashboard,
  getInventoryList,
  getMyProductList,
  getSupplierList,
  uploadImgPath,
  addNewProduct,
  getSeoInfo,
  editSeo,
  getBlogListCategory,
  deleteBlogCategory,
  updateBlogCategory,
  addNewBlogCategory,
  getBlogList,
  deleteBlog,
  changeStatusProduct,
  deleteProduct,
  getLadderPorduct,
  getLikeMemeberBlog,
  getNotificationList,
  shareProduct,
  shareMultiProduct,
  backProductt,
  updateBlog,
  addRocketProduct,
  getListRocketProduct,
  getAllBrands,
  shareProductToTelegram,
  getProductDetail,
  getSliderOption,
  addTemplateText,
  getTextTemplateList,
  updateTextTempate,
  deleteTextTempalte,
  insertOfficialHoliday,
  updateOfficialHoliday,
  deleteHoldiay,
  getOfficialHolidayList,
  updateProduct,
  getAllPropertyLevelTow,
  deleteChildImageProduct,
  getAllPropertyLevelTwo,
  getNotActiveProduct,
  getChangeBrandStatus,
  getUpdateBrandSeo,
  getShowSeo,
} from "../services/contentUnit";
import { successMessage, errorMessage } from "../utils/message";

// add new blog
export const useAddBlog = () =>
  useMutation(addNewBlog, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("بلاگ با موفقیت  اضافه شد");
    },
  });

export const useGetBlogList = (PageNumber, search) =>
  useInfiniteQuery(
    ["fetch-myProduct-list", search],
    ({ pageParam = 1 }) => getBlogListCategory(pageParam, search),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

export const useGetBlogOption = (pageNumber, search) =>
  useQuery(["fetch-blog-option"], () =>
    getBlogListCategory(pageNumber, search)
  );

export const useAddNewBlogCategory = () =>
  useMutation(addNewBlogCategory, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("دسته بندی با موفقیت اضافه شد");
    },
  });

export const useDeleteBlogCategory = () =>
  useMutation(deleteBlogCategory, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("حذف دسته بندی با موفقیت انحام شد");
    },
  });

export const useUpdateBlogCategory = () =>
  useMutation(updateBlogCategory, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("ویرایش دسته بندی با موفقیت انجام شد");
    },
  });

export const useGetBlogTable = (PageNumber, search) =>
  useInfiniteQuery(
    ["fetch-myProduct-list", search],
    ({ pageParam = 1 }) => getBlogList(pageParam, search),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

export const UseDeleteBlog = () =>
  useMutation(deleteBlog, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("حذف مطلب با موفقیت انجام شد");
    },
  });

export const useGetLikeMemeberBlog = () =>
  useMutation(getLikeMemeberBlog, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
  });

export const useEditBlog = () =>
  useMutation(updateBlog, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("ویرایش مطلب با موفیقت انجام شد");
    },
  });

// ---------------Slider--------------//

// add new Slide

export const useAddSlide = () =>
  useMutation(addSlider, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("اسلاید با موفقیت  اضافه شد");
    },
  });

export const useCachAllSlider = (pageNumber, locationFilter, search) =>
  useInfiniteQuery(
    ["fetch-all-slider", pageNumber, locationFilter, search],
    ({ pageParam = 1 }) => getSliderList(pageParam, locationFilter, search),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

export const useSlideStatusUpdate = () =>
  useMutation(ChangeSliderStatus, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("وضعیت اسلایدر با موفقیت عوض شد");
    },
  });

export const useUpdateSlider = () =>
  useMutation(updateSlider, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("ویرایش با موفیت انجام شد");
    },
  });

export const useGetSliderOption = () =>
  useQuery(["fetch-slider-option"], () => getSliderOption());

// ---------------Frequent Question--------------//

export const useAddCategoryQuestion = () =>
  useMutation(addCategoryQuestion, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("دسته بندی با موفقیت اضافه شد");
    },
  });

export const useGetCategoryList = (pageNumber, search) =>
  useInfiniteQuery(
    ["fetch-all-category", pageNumber, search],
    ({ pageParam = 1 }) => getCategoryList(pageParam, search),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

export const useDeleteCategory = () =>
  useMutation(deleteCategory, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("دسته بندی با موفقیت حذف شد");
    },
  });

export const useUpdateCategory = () =>
  useMutation(updateCategory, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("دسته بندی با موفقت ویرایش شد");
    },
  });

export const useAddNewAskQuestion = () =>
  useMutation(addNewASkQuestion, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("سوال با موفقیت اضافه شد");
    },
  });

export const useDeleteAskQuestion = () =>
  useMutation(deleteAskQuestion, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("سوال با موفقیت حذف شد");
    },
  });

export const useUpdateAskQuestion = () =>
  useMutation(updateAskQuestion, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("سوال با  موفقیت ویرایش شد");
    },
  });

export const useGetAskQuestionList = (pageNumber, search) =>
  useInfiniteQuery(
    ["fetch-all-ask-question", pageNumber, search],
    ({ pageParam = 1 }) => getAskQuestionList(pageParam, search),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

export const useGetAllCategory = () =>
  useQuery(["fetch-all-category-ask-question"], () => fetchAllCatergory());

export const useAddNewProperty = () =>
  useMutation(addNewPeroperty, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("دسته بندی با موفقیت اضافه شد");
    },
  });

export const useGetPropertyList = (pageNumber, search) =>
  useInfiniteQuery(
    ["fetch-all-property-list-table", pageNumber, search],
    ({ pageParam = 1 }) => getPropertyList(pageParam, search),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

export const useFetchAllPropertyList = () =>
  useQuery(["fetch-all-property-list"], () => getALLPropertyList());

// notification

export const useAddNotification = () => {
  const queryClient = useQueryClient();
  return useMutation(addNewNotification, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      queryClient.invalidateQueries("fetch-notif-list");
      successMessage("پیام با موفقیت اضافه شد");
    },
  });
};

export const useGetNotifList = (PageNumber, search) =>
  useInfiniteQuery(
    ["fetch-notif-list", PageNumber, search],
    ({ pageParam = 1 }) => getNotificationList(pageParam, search),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

export const useDeletePropertyLevelOne = () =>
  useMutation(deletePropertyLevelOne, {
    onError: (err) => {
      // errorMessage(err.message);
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("دسته بندی با موفقیت حذف شد");
    },
  });

export const useUpdatePropertyLevelOne = () =>
  useMutation(updatePropertyLevelOne, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("دسته بندی با موفقیت ویرایش شد");
    },
  });

export const useAddNewPropertyLevelTwo = () =>
  useMutation(addNewPropertyLevelTow, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("دسته بندی با موفقیت اضافه شد");
    },
  });

export const useGetPropertyListLevelTow = (pageNumber, search) =>
  useInfiniteQuery(
    ["fetch-property-list-level2", pageNumber, search],
    ({ pageParam = 1 }) => getPropertyListLevelTow(pageParam, search),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

export const useGetAllPropertyLevelTowOption = () =>
  useQuery(["fetch-all-level-tow"], () => getAllPropertyLevelTwo());

export const useGetAllPropertyLevelTow = () =>
  useQuery(["fetch-all-level2"], () => getAllPropertyLevelTow());

export const useDeletePropertyLevel2 = () =>
  useMutation(deletePropertyLevel2, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("دسته بندی با موفقیت حذف شد");
    },
  });

export const useUpdatePropertyLevel2 = () =>
  useMutation(updatePropertyLevel2, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("دسته بندی با موفقیت ویرایش شد");
    },
  });

// ---------------Area Coverd-----------//

// __________country

export const useAddNewCountry = () =>
  useMutation(addNewCountry, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("کشور با موفقیت اضافه شد");
    },
  });

export const useDeleteCountry = () =>
  useMutation(deleteCountry, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("کشور با موفقیت حذف شد");
    },
  });

export const useUpdateCountry = () =>
  useMutation(updateCountry, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("کشور با موفقیت ویرایش شد");
    },
  });

export const useGetListCountry = (pageNumber, search) =>
  useInfiniteQuery(
    ["fetch-all-country-list", pageNumber, search],
    ({ pageParam = 1 }) => getCountryList(pageParam, search),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

// ___________province

export const useAddNewProvince = () =>
  useMutation(addNewProvince, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("استان با موفقیت اضافه شد");
    },
  });

export const useDeleteProvince = () =>
  useMutation(deleteProvince, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("استان با موفقیت حذف شد");
    },
  });

export const useUpdateProvince = () =>
  useMutation(updateProvince, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("استان با موفقیت ویرایش شد");
    },
  });

export const useGetListProvince = (pageNumber, search) =>
  useInfiniteQuery(
    ["fetch-all-province-list", pageNumber, search],
    ({ pageParam = 1 }) => getProvinceList(pageParam, search),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

export const useGetCountryOption = () =>
  useQuery(["fetch-country-option"], () => getCountryOption());

// __________city

export const useAddNewCity = () =>
  useMutation(addNewCity, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("شهر با موفقیت اضافه شد");
    },
  });

export const useDeleteCity = () =>
  useMutation(deleteCity, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("شهر با موفقیت حذف شد");
    },
  });

export const useUpdateCity = () =>
  useMutation(updateCity, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("شهر با موفقیت ویرایش شد");
    },
  });

export const useGetListCity = (pageNumber, search) =>
  useInfiniteQuery(
    ["fetch-all-city-list", pageNumber, search],
    ({ pageParam = 1 }) => getCityList(pageParam, search),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

export const useGetProvinceOption = () =>
  useQuery(["fetch-all-province-option"], () => getProvinceOption());

// ______area

export const useAddNewArea = () =>
  useMutation(addNewArea, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("منطقه با موفقیت اضافه شد");
    },
  });

export const useDeleteArea = () =>
  useMutation(deleteArea, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("منطقه با موفقیت حذف شد");
    },
  });

export const useUpdateArea = () =>
  useMutation(updateArea, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("منطقه با موفقیت ویرایش شد");
    },
  });

export const useGetListArea = (pageNumber, search) =>
  useInfiniteQuery(
    ["fetch-all-area-list", pageNumber, search],
    ({ pageParam = 1 }) => getAreaList(pageParam, search),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

// product category

// levels product category
export const useAddNewCategory = () =>
  useMutation(addProductLevel, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("دسته بندی  با موفقیت اضافه شد");
    },
  });

export const useUpdateCategoryLevel = () =>
  useMutation(updateProductLevel, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("دسته بندی  با موفقیت ویرایش شد");
    },
  });

export const useDeleteCategoryLevel = () =>
  useMutation(deleteProductLevel, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("دسته بندی  با موفقیت اضافه شد");
    },
  });

export const useGetProductList1 = (search) =>
  useQuery(["fetch-all-product-category-level1", search], () =>
    getLevel1List(search)
  );

export const useGetProductList2 = (PageNumber, search) =>
  useInfiniteQuery(
    ["fetch-all-level2", PageNumber, search],
    ({ pageParam = 1 }) =>
      getLevve2List(PageNumber === "" ? "" : pageParam, search),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

export const useGetProdcutList3 = (PageNumber, search) =>
  useInfiniteQuery(
    ["fetch-all-level3", PageNumber, search],
    ({ pageParam = 1 }) =>
      getLevel3List(PageNumber === "" ? "" : pageParam, search),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

// Brand

export const useAddNewBrand = () =>
  useMutation(addNewBrand, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("برند با موفقیت اضافه شد");
    },
  });

export const useUpdateBrand = () =>
  useMutation(updateBrand, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("برند با موفقیت ویرایش شد");
    },
  });

export const useDeleteBrand = () =>
  useMutation(deleteBrand, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("برند با موفقیت حذف شد");
    },
  });

export const useGetBrandList = (PageNumber, search) =>
  useInfiniteQuery(
    ["fetch-brand-list", PageNumber, search],
    ({ pageParam = 1 }) => getBrandList(pageParam, search),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

export const useGetAllBrand = () =>
  useQuery(["get-all-brands"], () => getBrandList());
// Gender

export const useAddNewGender = () =>
  useMutation(addNewGender, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("جنسیت با موفقیت اضافه شد");
    },
  });

export const useUpdateGender = () =>
  useMutation(updateGender, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("جنسیت با موفقیت ویرایش شد");
    },
  });

export const useDeleteGender = () =>
  useMutation(deleteGender, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("جنسیت با موفقیت حذف شد");
    },
  });

export const useGetGenderList = (PageNumber, search) =>
  useInfiniteQuery(
    ["fetch-gender-list", PageNumber, search],
    ({ pageParam = 1 }) => getGenderList(pageParam, search),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

// Occation

export const useAddNewOccation = () =>
  useMutation(addNewOccation, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("مناسبتی با موفقیت اضافه شد");
    },
  });

export const useUpdateOccation = () =>
  useMutation(updateOccation, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("مناسبتی با موفقیت ویرایش شد");
    },
  });

export const useDeleteOccation = () =>
  useMutation(deleteOccation, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("مناسبتی با موفقیت حذف شد");
    },
  });

export const useGetOccationList = (PageNumber, search) =>
  useInfiniteQuery(
    ["fetch-occation-list", PageNumber, search],
    ({ pageParam = 1 }) => getOccationList(pageParam, search),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

export const useChangeOccationStatus = (id) =>
  useMutation(changeStatusOccation, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("وضعیت مناسبت با موفقیت عوض شد");
    },
  });

// Product

export const useGetRockedListProduct = (search, status) =>
  useInfiniteQuery(
    ["fetch-all-rocked-prodcut", search],
    ({ pageParam = 1 }) => getNotActiveProduct(pageParam, search, status),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

export const useUpdateStatusRockedProduct = () =>
  useMutation(ChangeRockedProductStatus, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("وضعیت محصول با موفقیت عوض شد");
    },
  });

export const useDeleteRockedProduct = () =>
  useMutation(DeleteRockedProduct, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage(" محصول با موفقیت حذف شد");
    },
  });

export const useGetSupplierList = () =>
  useQuery(["fetch-supplier-list"], () => getSupplierList());

export const useGetProductDetail = () =>
  useMutation(getProductDetail, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
  });

// finished Product

export const useGetFinishedProduct = (search, status) =>
  useInfiniteQuery(
    ["fetch-all-finished-product", search],
    ({ pageParam = 1 }) => getFinishedProduct(pageParam, search, status),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

export const useDeleteFinishedProduct = () =>
  useMutation(deleteFinishedProduct, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage(" محصول با موفقیت حذف شد");
    },
  });

export const useApplyExitFinishedProduct = () =>
  useMutation(applyExitProduct, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage(" درخواست موجود کردن با موفقیت انجام شد");
    },
  });

export const useUpdateFinishedStatus = () => useMutation();

// get information dashboard
export const useGetInformationDashbaord = () =>
  useQuery("information-content", getInformationDashboard);
// ADD NEW PRODUCT
export const useGetInventoryList = () =>
  useQuery(["fetch-inventory-list"], () => getInventoryList());

export const useGetImgPath = () =>
  useMutation(uploadImgPath(), {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
  });

export const useAddNewProduct = () =>
  useMutation(addNewProduct, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage(" محصول با موفقیت اضافه شد");
    },
  });

//   MY PRODUCT

export const useGetMyProductList = (search, status, brand) =>
  useInfiniteQuery(
    ["fetch-myProduct-list", search],
    ({ pageParam = 1 }) => getMyProductList(pageParam, status, brand, search),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

export const useGetProductList = (_PageNumber, status, brand, name, code) =>
  useInfiniteQuery(
    ["fetch-myProduct-list", brand, name, code],
    ({ pageParam = 1 }) => getMyProductList(pageParam, status, brand),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

// export const useGetTradesList = (pagenumber) =>
//   useInfiniteQuery(
//     "trades-list",
//     ({ pageParam = 1 }) => getTradesList(pageParam),
//     {
//       getNextPageParam: (lastPage, allPages) => {
//         return allPages.length + 1;
//       },
//     }
//   );

// change status product
export const useChangeStatusProduct = () => {
  const queryClient = useQueryClient();
  return useMutation(changeStatusProduct, {
    onSuccess: () => {
      successMessage("با موفقیت انجام شد");
      queryClient.invalidateQueries("fetch-myProduct-list");
    },
  });
};

// delete product
export const useDeleteProduct = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteProduct, {
    onSuccess: () => {
      successMessage("با موفقیت حذف شد");
      queryClient.invalidateQueries("fetch-myProduct-list", 1, "Barci");
    },
  });
};

// get ladder product
export const useGetLadderPorduct = () => {
  const queryClient = useQueryClient();
  return useMutation(getLadderPorduct, {
    onSuccess: () => {
      successMessage("با موفقیت آپدیت شد");
      queryClient.invalidateQueries("fetch-myProduct-list", 1, "Active");
    },
  });
};

// share product
export const useShareProduct = () => {
  const queryClient = useQueryClient();
  return useMutation(shareProduct, {
    onSuccess: () => {
      successMessage("با موفقیت منتشر شد");
      queryClient.invalidateQueries("fetch-myProduct-list", 1, "Barci");
    },
  });
};

// share products
export const useShareProducts = () => {
  const queryClient = useQueryClient();
  return useMutation(shareMultiProduct, {
    onSuccess: () => {
      successMessage("با موفقیت منتشر شد");
      queryClient.invalidateQueries("fetch-myProduct-list", 1, "Barci");
    },
  });
};

// handle back
export const useBackProduct = () => {
  const queryClient = useQueryClient();
  return useMutation(backProductt, {
    onSuccess: () => {
      successMessage("با موفقیت آپدیت شد");
      queryClient.invalidateQueries("fetch-myProduct-list", 1, "Barci");
    },
  });
};

// get list rocked product
export const useGetListRocketProduct = () =>
  useQuery("list-rocket-product", getListRocketProduct);

// add rocket product
export const useAddProduct = () => {
  const queryClient = useQueryClient();
  return useMutation(addRocketProduct, {
    onSuccess: () => {
      successMessage("با موفقیت آپدیت شد");
      queryClient.invalidateQueries("list-rocket-product");
    },
  });
};

// get all brands
export const useGetAllBrands = () => useQuery("list-brands", getAllBrands);

// share product to telegram
export const useShareToTelegram = () =>
  useMutation(shareProductToTelegram, {
    onSuccess: () => {
      successMessage("با موفقیت منتشر شد");
    },
  });

// export const useAllOrdersOnline = (pageNumber) =>
// useQuery(["all-online-order", pageNumber], () =>
//   getAllOderOnline(pageNumber)

// Seo

export const useGetSeoInfo = () =>
  useMutation(getSeoInfo, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
  });

export const useUpdateSeo = () =>
  useMutation(editSeo, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("ویرایش سِو با موفقیت انجام شد");
    },
  });

// text table template

export const useGetTemplateTextTable = () =>
  useQuery(["fetch-text-template"], () => getTextTemplateList());

export const useAddTemplateTextTable = () =>
  useMutation(addTemplateText, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("دسته بندی  با موفقیت اضافه شد");
    },
  });

export const useUpdateTextTempalte = () =>
  useMutation(updateTextTempate, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("ویرایش جدول  با موفقیت اضافه شد");
    },
  });

export const useDeleteTextTempalte = () =>
  useMutation(deleteTextTempalte, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("حذف جدول کلمات  با موفقیت اضافه شد");
    },
  });

// Official Holdiday

export const useInsertHoliday = () =>
  useMutation(insertOfficialHoliday, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("تعطیلی رسمی با موفقیت اضافه شد");
    },
  });

export const useUpdateHoliday = () =>
  useMutation(updateOfficialHoliday, {
    onError: (err) => {
      errorMessage(" عملیات ناموفق به اتمام رسید");
    },
    onSuccess: () => {
      successMessage("ویرایش تعطیلی رسمی با موفقیت انجام شد");
    },
  });

export const useDeleteHoliday = () =>
  useMutation(deleteHoldiay, {
    onError: (err) => {
      errorMessage("حذف انجام نشد");
    },
    onSuccess: () => {
      successMessage("تعطیلی با موفقیت حذف شد");
    },
  });

export const useGetHolidayList = (pageNumber, search) =>
  useQuery(
    ["fetch-all-official-holiday", pageNumber, search],
    ({ pageParam = 1 }) => getOfficialHolidayList(pageParam, search),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

// update product

export const useUpdateProduct = () =>
  useMutation(updateProduct, {
    onError: (e) => {
      errorMessage(e.message);
    },
    onSuccess: (e) => {
      successMessage("ویرایش محصول با موفقیت انجام شد");
    },
  });

export const useDeleteImgProduct = () =>
  useMutation(deleteChildImageProduct, {
    onError: (e) => {
      errorMessage(e.message);
    },
    onSuccess: (e) => {
      successMessage("حذف عکس با موفیقت انجام شد");
    },
  });

export const useGetChangeBrandStauts = () => {
  const queryClient = useQueryClient();
  return useMutation(getChangeBrandStatus, {
    onSuccess: () => {
      queryClient.invalidateQueries("fetch-brand-list");
      successMessage("وضعیت برند با موفقیت تغییر کرد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};

export const useGetUpdateBrandSeo = () => {
  const queryClient = useQueryClient();
  return useMutation(getUpdateBrandSeo, {
    onSuccess: () => {
      queryClient.invalidateQueries("fetch-brand-list");
      successMessage("ویرایش سئو برند انجام شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};
export const useGetShowSeo = (data) =>
  useQuery(["get-brand-seo", data], () => getShowSeo(data));
